const CELL_CLASS = 'border-r-0! px-4! py-3! text-gray-900! [tr:last-child_&]:border-b-0!';

export const SUMMARY_COLUMN = {
  minWidth: 'min-w-0',
  headerClass: 'border-b-0! border-r-0! px-4! py-3! text-xs! font-medium! uppercase whitespace-nowrap text-gray-500!',
  cellClass: `${CELL_CLASS} max-w-0`,
};

export const SUMMARY_VALUE_COLUMN = { ...SUMMARY_COLUMN, cellClass: `${CELL_CLASS} whitespace-nowrap font-regular!` };
